(function() {

  'use strict';



  if (window.__vq_init_it) return;

  window.__vq_init_it = true;



  /* ── STATS → Google Sheet ── */

  var SHEET_URL = 'https://script.google.com/macros/s/AKfycbxCzo6XGex6ceLfENE_5zGTJvjy6NcMO25dV51Ae0HZNhsW0AVcLJloOxHL6QwLwmV8/exec';

  function sendToSheet(params) {

    if (!SHEET_URL) return;

    try {

      var qs = Object.keys(params).map(function(k) { return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]); }).join('&');

      new Image().src = SHEET_URL + '?' + qs;

    } catch(e) {}

  }



  var DISCOUNT_CODE = 'QUIZ10';

  /* Rabatt-Link statt manuellem Abtippen (Projektregel: immer /discount/CODE?redirect=) */

  var DISCOUNT_URL = '/discount/' + DISCOUNT_CODE + '?redirect=/cart';





  var LS_KEY = 'viworo_quiz_it_v1';

  var LS_TTL_MS = 24 * 60 * 60 * 1000;

  function saveProgress() {

    try { localStorage.setItem(LS_KEY, JSON.stringify({ step: currentStep, answers: answers, ts: Date.now() })); } catch(e) {}

  }

  function loadProgress() {

    try {

      var raw = localStorage.getItem(LS_KEY);

      if (!raw) return null;

      var data = JSON.parse(raw);

      if (!data || typeof data.ts !== 'number' || Date.now() - data.ts > LS_TTL_MS) { localStorage.removeItem(LS_KEY); return null; }

      if (!Array.isArray(data.answers) || data.answers.length === 0) return null;

      if (typeof data.step !== 'number' || data.step < 0 || data.step >= QUESTIONS.length) return null;

      return data;

    } catch(e) { return null; }

  }

  function clearProgress() { try { localStorage.removeItem(LS_KEY); } catch(e) {} }



  var UI = {

    topBadge: 'La nostra raccomandazione',

    scentLabel: 'Profilo olfattivo:',

    tipLabel: 'Consiglio:',

    ctaBtn: 'Scopri ora',

    progressOf: 'di',

    whyPrefix: '',

    backBtn: 'Indietro'

  };



  var OILS = {

    lavanda: {

      handle: 'bio-lavanda-vera',

      latin: 'Lavandula angustifolia',

      name: 'Lavanda vera (Bio)',

      scent: 'Floreale, dolce-erbaceo, calmante',

      why: 'Il tuttofare degli oli essenziali. Nell\'aromaterapia tradizionale, la lavanda è apprezzata per le sue proprietà rilassanti e per favorire un sonno sereno e ristoratore.',

      tip: '1-2 gocce sul cuscino per dormire meglio. Ottimo anche diluito per piccole irritazioni cutanee.'

    },

    cembro: {

      handle: 'olio-di-pino-cembro-bio',

      latin: 'Pinus cembra',

      name: 'Pino cembro (Bio)',

      scent: 'Caldo-legnoso, resinoso, alpino',

      why: 'Il profumo delle Alpi in una boccetta. Il suo aroma caldo e legnoso crea un\'atmosfera di profonda tranquillità, ideale per trasformare la camera da letto in un rifugio alpino.',

      tip: 'Nel diffusore in camera da letto - idealmente accenderlo 30 minuti prima di coricarsi.'

    },

    ylang: {

      handle: 'bio-ylang-ylang',

      latin: 'Cananga odorata',

      name: 'Ylang-Ylang (Bio)',

      scent: 'Intensamente floreale, dolce, esotico-sensuale',

      why: 'Solleva l\'umore e ha un effetto equilibrante. Tradizionalmente noto per il suo effetto armonizzante su corpo e mente.',

      tip: 'Usare con parsimonia - 1-2 gocce bastano! Meraviglioso miscelato con bergamotto o cedro.'

    },

    cedro: {

      handle: 'bio-cedro',

      latin: 'Cedrus atlantica',

      name: 'Legno di cedro (Bio)',

      scent: 'Caldo-legnoso, balsamico, radicante',

      why: 'Radica e centra. Ideale quando i pensieri corrono e si desidera trovare la calma.',

      tip: 'Perfetto per meditazione e yoga. Miscelare con lavanda per un profondo rilassamento serale.'

    },

    rosmarino: {

      handle: 'rosmarinus',

      latin: 'Rosmarinus officinalis',

      name: 'Rosmarino (Bio)',

      scent: 'Fresco-erbaceo, canforato, limpido',

      why: 'Il profumo fresco ed erbaceo del rosmarino è un classico dell\'aromaterapia per ritrovare lucidità e concentrazione durante il lavoro o lo studio.',

      tip: '3-4 gocce nel diffusore durante il lavoro. Combinare con limone per una spinta extra di freschezza.'

    },

    menta: {

      handle: 'bio-menta-piperita',

      latin: 'Mentha piperita',

      name: 'Menta piperita (Bio)',

      scent: 'Intensamente fresco, rinfrescante, mentolato-limpido',

      why: 'L\'intenso aroma mentolato regala una sensazione di freschezza immediata. Nell\'aromaterapia tradizionale è apprezzata per la sua capacità di rinfrescare e rivitalizzare.',

      tip: 'Per una sensazione di fresco: 1 goccia diluita con olio MCT sulle tempie. Non adatto a bambini sotto i 6 anni.'

    },

    limone: {

      handle: 'bio-limone',

      latin: 'Citrus limon',

      name: 'Limone (Bio)',

      scent: 'Fresco-agrumato, brillante, tonificante',

      why: 'Un olio meravigliosamente fresco che purifica l\'aria, solleva l\'umore e favorisce la concentrazione.',

      tip: 'Crea un\'atmosfera fresca e pulita nel diffusore. Nota: fototossico sulla pelle - evitare prima dell\'esposizione al sole!'

    },

    lemongrass: {

      handle: 'bio-lemongrass',

      latin: 'Cymbopogon flexuosus',

      name: 'Lemongrass (Bio)',

      scent: 'Limonato-erbaceo, fresco, leggermente dolce',

      why: 'Rinfresca e tonifica - come una mini vacanza. Anche un repellente naturale per insetti in estate.',

      tip: 'In estate, usare come repellente naturale per zanzare nel diffusore o diluito come spray per ambienti.'

    },

    eucalipto: {

      handle: 'bio-eucalipto',

      latin: 'Eucalyptus globulus',

      name: 'Eucalipto globulus (Bio)',

      scent: 'Fresco-limpido, canforato, liberante',

      why: 'Un classico dell\'aromaterapia per le vie respiratorie. Il suo aroma fresco e penetrante dona una piacevole sensazione di respiro libero, come una boccata d\'aria fresca in montagna.',

      tip: 'Nella stagione fredda: 3-4 gocce nel diffusore o in acqua calda per suffumigi. Non adatto a bambini sotto i 6 anni.'

    },

    teatree: {

      handle: 'tea-tree-bio',

      latin: 'Melaleuca alternifolia',

      name: 'Tea Tree (Bio)',

      scent: 'Fresco-medicinale, erbaceo, purificante',

      why: 'L\'olio purificante per eccellenza. Nella tradizione aromaterapica è apprezzato per la sua versatilità nella cura della pelle e per purificare l\'aria degli ambienti.',

      tip: 'Tamponare 1 goccia pura sulle imperfezioni. Per aree cutanee più ampie, diluire sempre con olio MCT.'

    },

    ravintsara: {

      handle: 'ravintsara',

      latin: 'Cinnamomum camphora ct. 1,8-cineole',

      name: 'Ravintsara (Canfora)',

      scent: 'Fresco-canforato, simile all\'eucalipto, delicato',

      why: 'L\'alternativa delicata all\'eucalipto. Il suo aroma fresco ma morbido lo rende particolarmente adatto a persone sensibili e a chi cerca un compagno delicato per la stagione fredda.',

      tip: 'Nella stagione fredda: 2-3 gocce sulla pianta dei piedi (diluite con olio MCT) prima di coricarsi.'

    },

    cajeput: {

      handle: 'cajeput',

      latin: 'Melaleuca cajuputi',

      name: 'Cajeput',

      scent: 'Fresco, leggermente simile all\'eucalipto, delicato',

      why: 'L\'alternativa dolce all\'eucalipto - adatta anche a persone sensibili. Nella tradizione aromaterapica è un compagno morbido per la stagione fredda.',

      tip: 'Una buona scelta per il diffusore anche in famiglie con bambini più grandi (dai 6 anni) - più delicato dell\'eucalipto.'

    },

    pmugo: {

      handle: 'bio-pino-mugo',

      latin: 'Pinus mugo',

      name: 'Pino mugo (Bio)',

      scent: 'Fresco-resinoso, canforato, alpino',

      why: 'L\'aria fresca delle Alpi in una boccetta! Il suo aroma resinoso e balsamico dona una piacevole sensazione di respiro libero e porta la montagna in casa.',

      tip: 'Ideale per la sauna - 2-3 gocce nell\'acqua di infusione per un autentico feeling alpino.'

    },

    bergamotto: {

      handle: 'bio-bergamotto',

      latin: 'Citrus bergamia',

      name: 'Bergamotto (Bio)',

      scent: 'Agrumato-floreale, leggermente dolce, elegante',

      why: 'Un profumo unico che unisce la freschezza degli agrumi alla dolcezza dei fiori. Nella tradizione aromaterapica è apprezzato per la sua capacità di calmare e sollevare l\'umore allo stesso tempo.',

      tip: 'Nel diffusore la sera per scacciare la malinconia. Attenzione: fortemente fototossico - non applicare sulla pelle prima dell\'esposizione al sole!'

    },

    arancio: {

      handle: 'bio-arancio-dolce',

      latin: 'Citrus sinensis',

      name: 'Arancio dolce (Bio)',

      scent: 'Caldo-dolce, fruttato, solare-allegro',

      why: 'Crea un\'atmosfera rilassante. Calma, solleva l\'umore ed è uno degli oli essenziali meglio tollerati.',

      tip: 'Il punto di partenza perfetto per i principianti. Nel diffusore in cucina o in soggiorno per un\'atmosfera calda.'

    },

    incenso: {

      handle: 'incenso',

      latin: 'Boswellia carterii',

      name: 'Incenso (Bio)',

      scent: 'Caldo-resinoso, balsamico, profondo',

      why: 'L\'olio della meditazione per eccellenza. Il suo aroma profondo e resinoso, usato da millenni nei rituali spirituali, invita alla contemplazione e alla pace interiore.',

      tip: 'Per la meditazione: 2 gocce nel diffusore. Per la pelle matura: 1 goccia nella crema viso (diluita).'

    },

    geranio: {

      handle: 'geranio',

      latin: 'Pelargonium graveolens',

      name: 'Geranio',

      scent: 'Rosato-floreale, fresco-erbaceo, equilibrante',

      why: 'L\'olio cutaneo dal profumo di rosa. Tradizionalmente apprezzato per la cura della pelle di ogni tipo - inoltre è un repellente naturale per zanzare.',

      tip: '2-3 gocce nel bagnoschiuma o nello shampoo. Si miscela bene con quasi tutti gli altri oli.'

    },

    camomilla: {

      handle: 'camomilla-romana-bio',

      latin: 'Chamaemelum nobile',

      name: 'Camomilla romana (Bio)',

      scent: 'Caldo-erbaceo, dolce di mela, delicato',

      why: 'Pura dolcezza - adatta a bambini e pelli sensibili. Calma corpo, mente e pelle irritata allo stesso modo.',

      tip: 'L\'olio calmante più delicato. Ideale per bambini (diluito) in caso di irrequietezza o problemi di sonno.'

    },

    pepnero: {

      handle: 'olio-di-pepe-nero-bio',

      latin: 'Piper nigrum',

      name: 'Pepe nero (Bio)',

      scent: 'Speziato-caldo, pepato, stimolante',

      why: 'Riscalda dolcemente dall\'interno. Il suo aroma speziato e avvolgente è perfetto per un massaggio rilassante dopo lo sport o nelle sere d\'inverno.',

      tip: 'Per un olio da massaggio riscaldante: mescolare 2-3 gocce con olio MCT e massaggiare sui muscoli tesi.'

    },

    palmarosa: {

      handle: 'olio-di-palmarosa-bio-nepal',

      latin: 'Cymbopogon martinii',

      name: 'Palmarosa (Bio)',

      scent: 'Rosato-dolce, fresco-floreale, elegante',

      why: 'Il profumo di rosa tra gli oli d\'erba. Tradizionalmente apprezzato per la cura della pelle e profuma meravigliosamente floreale.',

      tip: '2-3 gocce nel bagnoschiuma o nella lozione per il corpo per una cura naturale della pelle dal profumo di rosa.'

    },

    patchouli: {

      handle: 'patchouli',

      latin: 'Pogostemon cablin',

      name: 'Patchouli',

      scent: 'Profondamente terroso, caldo-dolce, sensuale',

      why: 'Il più profondo di tutti i profumi. Radica come nessun altro olio, tradizionalmente apprezzato per la cura della pelle e migliora con l\'età.',

      tip: 'Meno è meglio - 1-2 gocce bastano! Miscelare con arancio dolce per un bel profumo caldo-dolce.'

    },

    wintergruen: {

      handle: 'olio-di-wintergreen-biologico',

      latin: 'Gaultheria procumbens',

      name: 'Wintergreen (Bio)',

      scent: 'Dolce-medicinale, mentolato-caldo, intenso',

      why: 'Un olio intenso e riscaldante. Il suo carattere caldo sulla pelle è un classico delle miscele da massaggio dopo intense fasi di movimento.',

      tip: 'Molto concentrato! Diluire max 1% (2 gocce in 10 ml di olio MCT). Non con anticoagulanti, in gravidanza o per bambini.'

    },

    cipresso: {

      handle: 'cypress',

      latin: 'Cupressus sempervirens',

      name: 'Cipresso',

      scent: 'Fresco-legnoso, resinoso, mediterraneo-elegante',

      why: 'La Toscana in una boccetta. Armonizza e centra - ideale per l\'irrequietezza interiore e la meditazione.',

      tip: 'Perfetto per yoga e meditazione. Miscelare con cedro e incenso per un profondo radicamento.'

    },

    litsea: {

      handle: 'bio-litsea-cubeba-olio-essenziale',

      latin: 'Litsea cubeba',

      name: 'Litsea Cubeba (Bio)',

      scent: 'Limonato-dolce, fresco-floreale, allegro',

      why: 'Come un dolce raggio di sole. Il profumo ricorda il limone ma più morbido e floreale - solleva l\'umore senza essere fototossico.',

      tip: 'L\'alternativa non fototossica agli oli agrumati per l\'uso sulla pelle. 3-4 gocce nel diffusore per il buonumore.'

    },

    mandarino: {

      handle: 'bio-mandarino-rosso',

      latin: 'Citrus reticulata',

      name: 'Mandarino rosso (Bio)',

      scent: 'Caldo-dolce, morbidamente fruttato, dolcemente allegro',

      why: 'Particolarmente mite e delicato - meravigliosamente adatto anche ai più piccoli. Calma, conforta e porta allegria.',

      tip: 'Per bambini: 1-2 gocce nel diffusore come aiuto per il sonno. Miscelare con lavanda per il perfetto duo della buonanotte.'

    },

    citronella: {

      handle: 'citronella',

      latin: 'Cymbopogon nardus',

      name: 'Citronella',

      scent: 'Fresco-verde, limonato-rosato, caratteristico',

      why: 'Il repellente naturale per zanzare n°1. Rinfresca l\'aria e tiene lontani gli insetti fastidiosi in estate.',

      tip: 'Spray antizanzare fai-da-te: 10-15 gocce + 100 ml acqua + 1 cucchiaio di alcol in flacone spray. Rinnovare ogni 2-3 ore.'

    },

    eucitriodora: {

      handle: 'olio-di-eucalipto-citriodora-biologico',

      latin: 'Corymbia citriodora',

      name: 'Eucalipto citriodora (Bio)',

      scent: 'Limonato-fresco, leggermente rosato, brillante',

      why: 'La sorella elegante dell\'eucalipto - limonato invece che medicinale! Anche un apprezzato repellente naturale per insetti.',

      tip: 'Diverso dall\'Eucalyptus Globulus: limonato-fresco, ideale come profumo estivo e repellente per insetti. Bello anche nel diffusore serale.'

    },

    lavhybrida: {

      handle: 'bio-lavanda',

      latin: 'Lavandula x hybrida',

      name: 'Lavandino (Ibrido di Lavanda) (Bio)',

      scent: 'Fresco-erbaceo, più canforato della lavanda, limpido',

      why: 'La sorella più fresca della lavanda. Più freschezza canforata, profumo più intenso - ideale per la profumazione degli ambienti e la pulizia.',

      tip: 'Più conveniente della Lavanda vera e più intenso - perfetto per il diffusore in soggiorno e spray detergenti fai-da-te.'

    },

    garofano: {

      handle: 'chiodi-di-garofano',

      latin: 'Eugenia caryophyllus',

      name: 'Chiodi di garofano',

      scent: 'Caldo-speziato, intenso, profondamente dolce',

      why: 'Un classico invernale rilassante. Riscalda, crea accoglienza e un\'atmosfera avvolgente - come il profumo del vin brulè.',

      tip: 'Estremamente intenso - solo 1-2 gocce nel diffusore! Ottimo con arancio e cannella per un\'atmosfera festiva.'

    },

    timo: {

      handle: 'olio-essenziale-di-timo-bio',

      latin: 'Thymus vulgaris',

      name: 'Timo (Bio)',

      scent: 'Forte-erbaceo, caldo-speziato, intenso',

      why: 'L\'erba potente del Mediterraneo. Nella tradizione aromaterapica è apprezzato per il suo aroma intenso e il supporto del benessere durante la stagione fredda.',

      tip: 'Forte e intenso - solo 1-2 gocce nel diffusore! Miscelare con limone per un profumo più fresco e delicato.'

    },

    zimtblatt: {

      handle: 'cannella',

      latin: 'Cinnamomum verum',

      name: 'Foglia di cannella',

      scent: 'Caldo-speziato, dolce di cannella, accogliente',

      why: 'Calore per l\'anima. Crea istantaneamente accoglienza e benessere - perfetto per la stagione fredda.',

      tip: 'Solo 2-3 gocce nel diffusore - molto intenso! Miscela natalizia: cannella + arancio + chiodi di garofano.'

    },

    pompelmo: {

      handle: 'pompelmo-bio',

      latin: 'Citrus paradisi',

      name: 'Pompelmo (Bio)',

      scent: 'Agrumato-aspro, leggermente amaro, tonificante',

      why: 'Aspro e rinfrescante - più brillante dell\'arancio, ideale per una mattina tonificante e pensieri lucidi.',

      tip: 'Nel diffusore al mattino per un inizio fresco della giornata. Nota: fototossico sulla pelle!'

    },

    salviamos: {

      handle: 'salvia-moscatella',

      latin: 'Salvia sclarea',

      name: 'Salvia sclarea',

      scent: 'Erbaceo-caldo, nocciolato-dolce, profondo',

      why: 'Un olio dall\'aroma avvolgente e profondo, tradizionalmente apprezzato in aromaterapia per il suo effetto armonizzante e rilassante.',

      tip: 'Per l\'irrequietezza: 3-4 gocce nel diffusore. Miscelare con lavanda e geranio per un mix femminile e armonioso.'

    },

    petitgrain: {

      handle: 'petitgrain',

      latin: 'Citrus aurantium',

      name: 'Petitgrain (Foglia di arancio amaro)',

      scent: 'Verde-fresco, floreale-erbaceo, elegante',

      why: 'Il profumo fresco e floreale dell\'arancio amaro - un\'alternativa accessibile al neroli. Calma la mente e dona serenità.',

      tip: 'Nelle fasi intense di lavoro o di studio: 2-3 gocce nel diffusore. Miscelare con bergamotto per puro rilassamento.'

    },

    fichte: {

      handle: 'bio-abete-rosso',

      latin: 'Picea abies',

      name: 'Abete rosso (Bio)',

      scent: 'Fresco, resinoso, tonificante',

      why: 'Il suo aroma fresco e resinoso rinvigorisce la mente e dona una piacevole sensazione di vitalità, come una camminata nel bosco di montagna.',

      tip: 'Eccellente per infusioni sauna tonificanti o come additivo rivitalizzante per il bagno.'

    },

    laerche: {

      handle: 'bio-larice',

      latin: 'Larix decidua',

      name: 'Larice (Bio)',

      scent: 'Caldo-legnoso, balsamico, delicato',

      why: 'Un olio raro e delicato dall\'aroma avvolgente. Nella tradizione alpina è apprezzato per il suo effetto protettivo e radicante.',

      tip: 'Un olio di conifera molto ben tollerato, ideale per chi cerca stabilità e radicamento.'

    },

    blutorange: {

      handle: 'bio-arancia-rossa',

      latin: 'Citrus sinensis',

      name: 'Arancio rosso (Bio)',

      scent: 'Frizzante-dolce, intenso, solare',

      why: 'Come un raggio di sole in boccetta. Il suo aroma frizzante e dolce porta allegria istantanea e crea atmosfere calde e accoglienti.',

      tip: 'Il nostro preferito per creare un\'atmosfera calda e accogliente negli spazi familiari.'

    },

    limette: {

      handle: 'bio-limetta',

      latin: 'Citrus aurantifolia',

      name: 'Lime (Bio)',

      scent: 'Aspro-fresco, frizzante, stimolante',

      why: 'Più vivace del limone. Schiarisce i pensieri confusi e favorisce la concentrazione creativa.',

      tip: 'Ideale per il diffusore sulla scrivania o per combattere la stanchezza di metà mattina.'

    },

    kuemmel: {

      handle: 'cumino-bio-dallungheria',

      latin: 'Carum carvi',

      name: 'Cumino dei prati (Bio)',

      scent: 'Speziato, terroso, caratteristico',

      why: 'Un olio speziato e caratteristico dalla lunga tradizione delle erbe mediterranee. Il suo aroma terroso è un compagno conosciuto in aromaterapia per momenti di calore e quiete.',

      tip: 'Diluito in olio MCT all\'1% per un caldo e rilassante impacco serale sul ventre dopo pasti abbondanti.'

    },

    fenchel: {

      handle: 'olio-essenziale-di-finocchio-biologico',

      latin: 'Foeniculum vulgare',

      name: 'Finocchio (Bio)',

      scent: 'Dolce, simile all\'anice, caldo',

      why: 'Un classico morbido-dolce della cucina mediterranea. Il suo aroma delicato, simile all\'anice, è conosciuto in aromaterapia per la sua nota calma e armonizzante.',

      tip: 'Diluito (max 1%) in un olio vettore per una delicata e calda applicazione serale sulla parte alta del ventre.'

    },

    anis: {

      handle: 'anice-stellato',

      latin: 'Illicium verum',

      name: 'Anice stellato',

      scent: 'Dolce, speziato, riscaldante',

      why: 'Un aroma caldo e avvolgente che porta una sensazione di comfort nella stagione fredda e crea un\'atmosfera accogliente.',

      tip: '2-3 gocce nel diffusore con arancio dolce e cannella - un classico profumo invernale per il soggiorno.'

    },

    oregano: {

      handle: 'oregano',

      latin: 'Origanum vulgare',

      name: 'Origano (Bio)',

      scent: 'Erbaceo, speziato, intenso',

      why: 'Uno degli oli essenziali più potenti e intensi. Nella tradizione aromaterapica è apprezzato per le sue proprietà purificanti.',

      tip: 'Usare solo sotto guida esperta! Altamente irritante - mai applicare puro sulla pelle.'

    },

    salbei: {

      handle: 'salvia',

      latin: 'Salvia officinalis',

      name: 'Salvia (Bio)',

      scent: 'Erbaceo, limpido, amaro',

      why: 'Fortemente purificante per mente e spazio. Il suo aroma erbaceo e limpido è usato da millenni nelle tradizioni di purificazione.',

      tip: 'Usare con cautela - molto potente. Non usare in gravidanza.'

    }

  };



  var QUESTIONS = [

    {

      title: 'Qual è il tuo obiettivo principale?',

      subtitle: 'Scegli l\'ambito che ha la massima priorità per te.',

      options: [

        { icon: '🌲', label: 'Forza del bosco & vie respiratorie', desc: 'Rigenerazione profonda e respirazione libera come in alta montagna.', scores: { fichte: 14, laerche: 13, cembro: 10, pmugo: 10, eucalipto: 16, ravintsara: 10, lavhybrida: 3, citronella: 2 } },

        { icon: '⚡', label: 'Energia & buon umore', desc: 'Allegria immediata e lucidità mentale.', scores: { blutorange: 15, limette: 12, limone: 10, pompelmo: 10, rosmarino: 10, litsea: 8, arancio: 7, lemongrass: 5 } },

        { icon: '😴', label: 'Relax profondo & sonno', desc: 'Spegnere i pensieri e migliorare la qualità del sonno.', scores: { cembro: 15, lavanda: 12, incenso: 12, camomilla: 10, cedro: 8, ylang: 8, mandarino: 8, salviamos: 7, patchouli: 6, petitgrain: 5 } },

        { icon: '🧘', label: 'Centratura & equilibrio', desc: 'Calore per la zona addominale e una sensazione di radicamento.', scores: { kuemmel: 15, fenchel: 12, anis: 10, menta: 13, salbei: 5 } },

        { icon: '🛡️', label: 'Protezione & atmosfera', desc: 'Compagni naturali per la stagione fredda e un ambiente fresco.', scores: { ravintsara: 15, teatree: 12, timo: 10, oregano: 10, garofano: 8, eucalipto: 12, cajeput: 7, citronella: 3, salbei: 5 } },

        { icon: '💪', label: 'Muscoli & recupero', desc: 'Calore e relax dopo intensa attività fisica.', scores: { wintergruen: 15, pepnero: 12, rosmarino: 10, menta: 8, fichte: 5 } }

      ]

    },

    {

      title: 'Come ti senti in questo momento?',

      subtitle: 'Scegli il tuo stato emotivo o fisico.',

      options: [

        { icon: '😰', label: 'Stressato/a e teso/a', desc: 'Troppi pensieri, irrequietezza interiore.', scores: { lavanda: 10, bergamotto: 10, cedro: 8, ylang: 7, blutorange: 7, cipresso: 6, salviamos: 5, petitgrain: 5, geranio: 3, palmarosa: 3, incenso: 8 } },

        { icon: '😴', label: 'Stanco/a e svogliato/a', desc: 'Ho bisogno di una spinta di concentrazione.', scores: { limone: 10, rosmarino: 10, menta: 14, limette: 8, pompelmo: 8, litsea: 7, lemongrass: 5 } },

        { icon: '🤒', label: 'Congestionato/a e debole', desc: 'Primi segni di raffreddore.', scores: { fichte: 10, ravintsara: 10, eucalipto: 8, timo: 8, cajeput: 7, pmugo: 7, laerche: 7, lavhybrida: 3, eucitriodora: 3 } },

        { icon: '😟', label: 'Sopraffatto/a e vulnerabile', desc: 'Cerco protezione e conforto.', scores: { laerche: 12, incenso: 18, cedro: 10, patchouli: 7, arancio: 6 } },

        { icon: '😣', label: 'Gonfiore e malessere', desc: 'Sensazione di pressione nell\'addome.', scores: { kuemmel: 12, fenchel: 10, anis: 8, camomilla: 5 } }

      ]

    },

    {

      title: 'Quale direzione olfattiva preferisci?',

      subtitle: 'Questo ci aiuta a trovare il tuo olio preferito.',

      options: [

        { icon: '🌲', label: 'Boscoso e fresco', desc: 'Abete rosso, Cirmolo, Larice, Pino mugo', scores: { fichte: 5, laerche: 5, cembro: 5, pmugo: 5, cipresso: 7, salbei: 3 } },

        { icon: '🍋', label: 'Agrumato e fresco', desc: 'Limone, Arancia, Lime, Bergamotto', scores: { limone: 5, blutorange: 5, limette: 5, pompelmo: 5, litsea: 5, arancio: 4, bergamotto: 4, eucitriodora: 3, lemongrass: 4, citronella: 3 } },

        { icon: '🌸', label: 'Fiorito e morbido', desc: 'Lavanda, Geranio, Ylang Ylang', scores: { lavanda: 5, geranio: 5, ylang: 5, palmarosa: 5, camomilla: 4, salviamos: 3, lavhybrida: 3, petitgrain: 3 } },

        { icon: '🪵', label: 'Speziato e terroso', desc: 'Cedro, Patchouli, Incenso, Pepe', scores: { cedro: 5, patchouli: 5, incenso: 5, pepnero: 4, kuemmel: 4, garofano: 3, zimtblatt: 3 } },

        { icon: '🎲', label: 'Sorprendimi!', desc: 'Nessuna preferenza - sono aperto/a a tutto.', scores: {} }

      ]

    },

    {

      title: 'Ci siamo quasi - un ultimo dettaglio per la tua raccomandazione personale',

      subtitle: 'Così scegliamo gli oli più adatti alla tua quotidianità.',

      options: [

        { icon: '✅', label: 'Solo per me - nessuna restrizione', desc: 'Mostrami le migliori raccomandazioni.', scores: {} },

        { icon: '🤰', label: 'Gravidanza / Allattamento', desc: 'Raccomanderemo solo oli delicati.', scores: { salbei: -20, salviamos: -20, wintergruen: -20, timo: -20, garofano: -20, zimtblatt: -20, oregano: -20, menta: -10, rosmarino: -5 } },

        { icon: '👶', label: 'Bambini piccoli in casa', desc: 'Sceglieremo oli particolarmente miti per te.', scores: { menta: -20, eucalipto: -20, timo: -20, oregano: -20, wintergruen: -20, garofano: -20, salbei: -20 } },

        { icon: '🧴', label: 'Pelle molto sensibile', desc: 'Eviteremo componenti irritanti.', scores: { timo: -10, oregano: -10, garofano: -10, zimtblatt: -10, menta: -5, limone: -2, lemongrass: -3 } }

      ]

    },
    {
      title: 'Come vuoi usare il tuo olio?',
      subtitle: 'Così ricevi il consiglio giusto e il formato adatto.',
      options: [
        { icon: '💨', label: 'Nel diffusore e per l\'ambiente', desc: 'Profumo in soggiorno, ufficio o camera.', scores: { limone: 2, blutorange: 2, bergamotto: 2, lavanda: 2, eucalipto: 2, cembro: 2 } },
        { icon: '🤲', label: 'Sulla pelle e per massaggi', desc: 'Diluito con un olio vettore.', scores: { lavanda: 3, geranio: 2, palmarosa: 2, camomilla: 2, incenso: 2, menta: -3, timo: -3, oregano: -3 } },
        { icon: '🔥', label: 'Per sauna e bagno', desc: 'Per il vapore e come additivo da bagno.', scores: { fichte: 3, pmugo: 3, laerche: 3, cembro: 3, eucalipto: 2, rosmarino: 2 } },
        { icon: '🤔', label: 'Non lo so ancora', desc: 'Mostrami semplicemente il consiglio migliore.', scores: {} }
      ]
    }
  ];



  /* ── TRACKING (GA4 / GTM) ── */

  function trackEvent(name, params) {

    try {

      if (typeof gtag === 'function') gtag('event', name, params || {});

      if (window.dataLayer) { var e = { event: name }; if (params) { for (var k in params) { e[k] = params[k]; } } dataLayer.push(e); }

    } catch(err) {}

  }



  var currentStep = -1;

  var answers = [];

  var totalQuestions = QUESTIONS.length;



  var quizEl = document.getElementById('viworo-quiz');

  var introEl = quizEl.querySelector('.vq-intro');

  var progressWrap = quizEl.querySelector('.vq-progress-wrap');

  var progressFill = quizEl.querySelector('.vq-progress-fill');

  var progressText = quizEl.querySelector('.vq-progress-text');

  var questionEl = quizEl.querySelector('.vq-question');

  var resultsEl = quizEl.querySelector('.vq-results');



  function showScreen(name) {
    /* V2: Ratgebertext und FAQ nur ausserhalb des Ergebnisses zeigen. */
    try { document.body.classList.toggle('vq-ergebnis', name === 'results'); } catch(e) {}

    [introEl, questionEl, resultsEl].forEach(function(s) {

      s.style.display = 'none';

      s.classList.remove('active');

    });

    progressWrap.style.display = (name === 'question') ? 'flex' : 'none';

    var target = name === 'intro' ? introEl : name === 'question' ? questionEl : resultsEl;

    target.style.display = 'block';

    requestAnimationFrame(function() {

      target.classList.add('active');

      var focusTarget = name === 'question' ? target.querySelector('.vq-q-title') :

                        name === 'results' ? target.querySelector('.vq-results-title') :

                        target.querySelector('.vq-title') || target;

      if (focusTarget) {

        focusTarget.setAttribute('tabindex', '-1');

        focusTarget.focus({ preventScroll: false });

      }

    });

  }



  function startQuiz() {

    trackEvent('quiz_start');

    sendToSheet({ t: 'start', lang: 'it' });

    currentStep = 0;

    answers = [];

    clearProgress();

    showScreen('question');

    renderQuestion(0);

  }



  function resumeQuiz(data) {

    trackEvent('quiz_resume', { quiz_step: data.step + 1 });

    currentStep = data.step;

    answers = data.answers.slice();

    showScreen('question');

    renderQuestion(currentStep);

  }



  function goBack() {

    if (currentStep > 0) {

      currentStep--;

      answers.pop();

      saveProgress();

      renderQuestion(currentStep);

    }

  }



  var isTransitioning = false;

  function selectOption(optIndex) {

    if (isTransitioning) return;

    isTransitioning = true;

    trackEvent('quiz_answer', { quiz_step: currentStep + 1, quiz_choice: QUESTIONS[currentStep].options[optIndex].label });

    var options = questionEl.querySelectorAll('.vq-option');

    for (var i = 0; i < options.length; i++) {

      options[i].setAttribute('aria-pressed', i === optIndex ? 'true' : 'false');

      options[i].classList.toggle('vq-selected', i === optIndex);

    }

    answers[currentStep] = optIndex;

    setTimeout(function() {

      currentStep++;

      isTransitioning = false;

      if (currentStep < totalQuestions) {

        saveProgress();

        renderQuestion(currentStep);

      } else {

        showResults();

      }

    }, 120);

  }



  function renderQuestion(idx) {

    var q = QUESTIONS[idx];

    var pct = ((idx + 1) / totalQuestions) * 100;

    progressFill.style.width = pct + '%';

    quizEl.querySelector('.vq-progress-bar').setAttribute('aria-valuenow', Math.round(pct));

    progressText.textContent = (idx + 1) + ' ' + UI.progressOf + ' ' + totalQuestions;

    questionEl.querySelector('.vq-q-title').textContent = q.title;

    questionEl.querySelector('.vq-q-subtitle').textContent = q.subtitle;

    var optWrap = questionEl.querySelector('.vq-options');

    optWrap.innerHTML = '';

    q.options.forEach(function(opt, i) {

      var card = document.createElement('button');

      card.type = 'button';

      card.className = 'vq-option';

      card.setAttribute('aria-pressed', 'false');

      card.innerHTML =

        '<span class="vq-option-icon" aria-hidden="true">' + opt.icon + '</span>' +

        '<span class="vq-option-text">' +

          '<span class="vq-option-label">' + opt.label + '</span>' +

          '<span class="vq-option-desc">' + opt.desc + '</span>' +

        '</span>';

      card.addEventListener('click', function() { selectOption(i); });

      optWrap.appendChild(card);

    });

    var backBtn = questionEl.querySelector('.vq-btn-back');

    backBtn.style.display = idx > 0 ? 'inline-block' : 'none';

    showScreen('question');

  }



  /* Hard-Stop: Oli esclusi per sicurezza */

  var BLACKLIST = {

    1: ['wintergruen', 'salviamos', 'salbei', 'timo', 'garofano', 'zimtblatt', 'oregano', 'menta', 'rosmarino', 'fenchel'],

    2: ['wintergruen', 'menta', 'eucalipto', 'timo', 'oregano', 'garofano', 'salbei']

  };



  var SYNERGIES = [

    { oils: ['lavanda', 'cedro'], context: [2], bonus: 4 },

    { oils: ['lavanda', 'cembro'], context: [2], bonus: 4 },

    { oils: ['eucalipto', 'ravintsara'], context: [0, 4], bonus: 4 },

    { oils: ['bergamotto', 'arancio'], context: [1], bonus: 4 },

    { oils: ['pepnero', 'rosmarino'], context: [5], bonus: 4 },

    { oils: ['menta', 'rosmarino'], context: [1], bonus: 2 },

    { oils: ['kuemmel', 'fenchel'], context: [3], bonus: 4 },

    { oils: ['fichte', 'laerche'], context: [0], bonus: 4 }

  ];



  function calculateScores() {

    var scores = {};

    var reasons = {};

    Object.keys(OILS).forEach(function(key) { scores[key] = 0; reasons[key] = []; });

    answers.forEach(function(optIdx, qIdx) {

      var opt = QUESTIONS[qIdx].options[optIdx];

      var weight = (qIdx === 0) ? 2 : 1;

      if (opt && opt.scores) {

        Object.keys(opt.scores).forEach(function(oilKey) {

          if (scores[oilKey] !== undefined) {

            scores[oilKey] += opt.scores[oilKey] * weight;

            if (opt.scores[oilKey] > 0) {

              reasons[oilKey].push({ q: qIdx, label: opt.label, contribution: opt.scores[oilKey] * weight });

            }

          }

        });

      }

    });



    var q4 = answers[3];

    var banned = BLACKLIST[q4] || [];

    banned.forEach(function(key) { delete scores[key]; delete reasons[key]; });



    var q1 = answers[0];

    SYNERGIES.forEach(function(syn) {

      if (syn.context.indexOf(q1) === -1) return;

      var allPositive = syn.oils.every(function(o) { return scores[o] && scores[o] > 0; });

      if (allPositive) {

        syn.oils.forEach(function(o) { scores[o] += syn.bonus; });

      }

    });



    var positive = Object.keys(scores).filter(function(k) { return scores[k] > 0; });

    positive.sort(function(a, b) {

      var diff = scores[b] - scores[a];

      return diff !== 0 ? diff : (a < b ? -1 : 1);

    });

    var maxScore = positive.length > 0 ? scores[positive[0]] : 1;

    var results = [];

    for (var i = 0; i < positive.length && results.length < 3; i++) {

      var key = positive[i];

      var matchPct = Math.round((scores[key] / maxScore) * 100);

      var topReasons = (reasons[key] || []).slice().sort(function(a, b) { return b.contribution - a.contribution; }).slice(0, 2);

      results.push({ key: key, score: scores[key], match: matchPct, reasons: topReasons });

    }

    if (results.length === 0) { results.push({ key: 'lavanda', score: 1, match: null, reasons: [] }); }

    return results;

  }



  function markUnavailable(btn) {

    if (!btn) return;

    btn.disabled = true;

    btn.style.background = '#9ca3af';

    btn.style.cursor = 'default';

    btn.innerHTML = 'Al momento non disponibile';

    btn.setAttribute('aria-label', 'Al momento non disponibile');

  }



  function getProductUrl(handle) {

    var root = quizEl.getAttribute('data-root-url') || '';

    if (root && root !== '/') { return root + 'products/' + handle; }

    var path = window.location.pathname;

    var prefixes = ['/it/'];

    var base = '';

    for (var i = 0; i < prefixes.length; i++) {

      if (path.indexOf(prefixes[i]) === 0) {

        base = prefixes[i].slice(0, -1);

        break;

      }

    }

    return base + '/products/' + handle;

  }



  /* ════════════════════════════════════════════════════════════════
     QUIZ V2 (29.08.2026) — neuer Ergebnisbildschirm
     - eine klare Nr. 1 mit Produktbild, ein Hauptknopf
     - Daten (Titel/Preis/Bild/Varianten) aus dem MARKT, nicht aus dem Code
     - ausverkaufte Oele werden nie Nr. 1
     - "Ueberrasch mich" bekommt eine Entscheidung statt einer Auswahl
     - Groessenwahl, Set-Preis, Versandbalken, Sticky-Kaufleiste
     ════════════════════════════════════════════════════════════════ */

  var V2 = {"lang": "it", "q1": {"0": "cerchi la forza del bosco e vie respiratorie libere", "1": "vuoi energia e buon umore", "2": "vuoi dormire meglio", "3": "cerchi equilibrio interiore", "4": "cerchi un alleato per la stagione fredda", "5": "vuoi recuperare dopo lo sport"}, "q2": {"0": "sei teso/a", "1": "sei stanco/a", "2": "ti senti gi\u00f9 di tono", "3": "hai bisogno di protezione", "4": "ti senti gonfio/a"}, "q5": {"0": "Nel diffusore bastano 3\u20135 gocce.", "1": "Sulla pelle diluisci sempre con un olio vettore.", "2": "Per la sauna conviene il flacone da 30 ml.", "3": ""}, "und": " e ", "weil": "Adatto a te perch\u00e9 ", "titel": "Il tuo olio: {oel}", "sub": "Tra oltre 35 oli bio, quello che si adatta meglio alle tue risposte.", "titelUeberrasch": "Abbiamo scelto per te.", "subUeberrasch": "Volevi essere sorpreso/a \u2013 ecco l'olio giusto per te.", "badge": "Consigliato", "badgeUeberrasch": "La tua sorpresa", "warumTitel": "Perch\u00e9 proprio questo olio", "punkt1": "Hai scelto {x}.", "punkt2": "Ti senti {x}.", "cta": "Aggiungi al carrello", "ctaUeberrasch": "S\u00ec, lo provo", "zurSeite": "Vai alla scheda prodotto", "proAnwendung": "Da {p} \u20ac per applicazione \u00b7 circa 250 gocce", "groesseLabel": "Scegli il formato", "auchPassend": "Anche adatti", "altAufklappen": "Vuoi confrontare? Mostra due alternative", "setTitel": "Tutti e {n} insieme", "setBtn": "Aggiungi il set", "dazuPasst": "Si abbina bene", "hinzu": "Aggiungi", "wirdHinzu": "Aggiungo\u2026", "imKorb": "Nel carrello", "fehler": "Errore \u2013 riprova", "sicher": "Abbiamo escluso {n} oli che non si adattano alla tua indicazione.", "versandSchwelle": 25, "versandNoch": "Ancora {x} per la spedizione gratuita", "versandFrei": "\u2713 Spedizione gratuita raggiunta", "versandKurz": "Spedizione gratuita da 25 \u20ac", "codeText": "10 % sul tuo ordine \u00b7 uno per cliente", "codeBtn": "Applica", "laedt": "Sto caricando il tuo consiglio\u2026", "leer": "Al momento nessuno degli oli adatti \u00e8 disponibile. Riprova pi\u00f9 tardi.", "zubehoer": {"0": "diffusore-ad-ultrasuoni-da-400-ml", "1": "olio-mct-bio", "2": null, "3": null}, "zubehoerText": {"0": "Bastano 3\u20135 gocce per tutta la stanza", "1": "Per diluire su pelle e massaggi", "2": "", "3": ""}, "tipp": {"0": "3\u20135 gocce nel diffusore \u2013 per ambienti fino a circa 30 m\u00b2.", "1": "Diluisci con un olio vettore: 2\u20133 gocce in un cucchiaino di olio MCT.", "2": "Per la sauna 5\u201310 gocce in un litro d'acqua \u2013 mai puro sulle pietre.", "3": null}};

  function fmtPreis(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* Produktdaten vom AKTUELLEN Markt holen (richtige Sprache, richtiger Preis). */
  function ladeProdukt(handle) {
    var url = getProductUrl(handle) + '.js';
    return fetch(url)
      .then(function(r) { if (!r.ok) throw new Error('404'); return r.json(); })
      .then(function(p) {
        var varianten = (p.variants || []).filter(function(v) { return v.available; });
        return {
          ok: varianten.length > 0,
          handle: handle,
          titel: p.title || '',
          bild: p.featured_image || (p.images && p.images[0]) || null,
          varianten: varianten.map(function(v) {
            return { id: v.id, titel: v.title, preis: v.price };
          })
        };
      })
      .catch(function() { return { ok: false, handle: handle, titel: '', bild: null, varianten: [] }; });
  }

  /* Ein Satz, der ALLE Antworten aufgreift - nicht nur Frage 1 und 3. */
  function begruendung() {
    var teile = [];
    if (V2.q1[answers[0]]) teile.push(V2.q1[answers[0]]);
    if (V2.q2[answers[1]]) teile.push(V2.q2[answers[1]]);
    var satz = teile.length === 2 ? (teile[0] + V2.und + teile[1])
             : teile.length === 1 ? teile[0] : '';
    if (!satz) return '';
    var s = V2.weil + satz + '.';
    if (answers[4] !== undefined && V2.q5[answers[4]]) s += ' ' + V2.q5[answers[4]];
    return s;
  }

  /* Wurden Oele aus Sicherheitsgruenden ausgeschlossen? Das gehoert sichtbar gemacht. */
  function ausgeschlossen() {
    var b = BLACKLIST[answers[3]];
    return (b && b.length) ? b.length : 0;
  }

  /* Zubehoer passend zur Anwendung (Frage 5). */
  function zubehoerHandle() {
    if (answers[4] === undefined) return null;
    var z = V2.zubehoer[answers[4]];
    return z || null;
  }

  function showResults() {
    var results = calculateScores();
    var namen = results.map(function(r) { return OILS[r.key].name; });
    trackEvent('quiz_complete', { quiz_top1: namen[0] || '', quiz_top2: namen[1] || '', quiz_top3: namen[2] || '' });
    var sheetDaten = {
      t: 'done', lang: V2.lang,
      q1: answers[0] !== undefined ? QUESTIONS[0].options[answers[0]].label : '',
      q2: answers[1] !== undefined ? QUESTIONS[1].options[answers[1]].label : '',
      q3: answers[2] !== undefined ? QUESTIONS[2].options[answers[2]].label : '',
      q4: answers[3] !== undefined ? QUESTIONS[3].options[answers[3]].label : '',
      q5: (answers[4] !== undefined && QUESTIONS[4]) ? QUESTIONS[4].options[answers[4]].label : '',
      r1: namen[0] || '', r2: namen[1] || '', r3: namen[2] || ''
    };
    sendToSheet(sheetDaten);

    progressFill.style.width = '100%';
    quizEl.querySelector('.vq-progress-bar').setAttribute('aria-valuenow', 100);
    var cardsWrap = resultsEl.querySelector('.vq-results-cards');
    cardsWrap.innerHTML = '<div class="vq-laedt">' + V2.laedt + '</div>';
    var stale = resultsEl.querySelectorAll('.vq-urgency-banner, .vq-bundle-wrap, .vq-share-wrap, .vq-discount-box, .vq-v2-block, .vq-sticky');
    for (var s = 0; s < stale.length; s++) { stale[s].remove(); }
    showScreen('results');

    /* Erst alle Produktdaten holen, dann rendern - so steht nie ein falscher
       Preis auf dem Schirm und Ausverkauftes wird gar nicht erst Nr. 1. */
    var alle = results.map(function(r) { return ladeProdukt(OILS[r.key].handle); });
    var zh = zubehoerHandle();
    if (zh) alle.push(ladeProdukt(zh));

    Promise.all(alle).then(function(prods) {
      var zubehoer = zh ? prods.pop() : null;
      var paare = [];
      for (var i = 0; i < results.length; i++) {
        if (prods[i] && prods[i].ok) paare.push({ r: results[i], p: prods[i] });
      }
      if (paare.length === 0) {
        cardsWrap.innerHTML = '<div class="vq-leer">' + V2.leer + '</div>';
        return;
      }
      rendere(paare, zubehoer);
    });
  }

  function rendere(paare, zubehoer) {
    var cardsWrap = resultsEl.querySelector('.vq-results-cards');
    cardsWrap.innerHTML = '';
    var ueberrasch = QUESTIONS[2].options[answers[2]] && QUESTIONS[2].options[answers[2]].surprise === true;
    var top = paare[0];
    var rest = paare.slice(1);

    /* ── Kopfzeile: die gewaehlten Antworten als Chips ── */
    var personalEl = resultsEl.querySelector('.vq-results-personal');
    var chips = '';
    for (var qi = 0; qi < QUESTIONS.length; qi++) {
      if (answers[qi] === undefined) continue;
      var o = QUESTIONS[qi].options[answers[qi]];
      if (!o) continue;
      chips += '<span class="vq-chip">' + (o.icon || '') + ' ' + esc(o.label) + '</span>';
    }
    personalEl.innerHTML = '<div class="vq-chips">' + chips + '</div>' +
      '<h3 class="vq-erg-titel">' + (ueberrasch ? V2.titelUeberrasch : V2.titel.replace('{oel}', esc(top.p.titel))) + '</h3>' +
      '<p class="vq-erg-sub">' + (ueberrasch ? V2.subUeberrasch : V2.sub) + '</p>';

    /* ── Nr. 1 als Hauptkarte ── */
    var hero = document.createElement('div');
    hero.className = 'vq-hero';
    var oil = OILS[top.r.key];
    var vs = top.p.varianten;
    var gruende = begruendung();
    var n = ausgeschlossen();

    var h = '<div class="vq-hero-top">';
    if (top.p.bild) {
      h += '<img class="vq-hero-bild" src="' + top.p.bild + '&width=260" alt="' + esc(top.p.titel) + '" loading="eager" width="118" height="118">';
    }
    h += '<div class="vq-hero-kopf">';
    h += '<span class="vq-badge">' + (ueberrasch ? V2.badgeUeberrasch : V2.badge + (top.r.match ? ' · ' + top.r.match + '% Match' : '')) + '</span>';
    h += '<div class="vq-hero-name">' + esc(top.p.titel) + '</div>';
    h += '<div class="vq-hero-latein">' + esc(oil.latin) + '</div>';
    h += '</div></div>';

    if (ueberrasch) {
      h += '<div class="vq-warum-box"><b>' + V2.warumTitel + '</b><ul>';
      if (V2.q1[answers[0]]) h += '<li>' + V2.punkt1.replace('{x}', '<b>' + esc(QUESTIONS[0].options[answers[0]].label) + '</b>') + '</li>';
      if (V2.q2[answers[1]]) h += '<li>' + V2.punkt2.replace('{x}', '<b>' + esc(QUESTIONS[1].options[answers[1]].label) + '</b>') + '</li>';
      h += '<li>' + esc(oil.why) + '</li>';
      h += '</ul></div>';
    } else {
      if (gruende) h += '<div class="vq-warum">' + gruende + '</div>';
      h += '<p class="vq-hero-why">' + esc(oil.why) + '</p>';
    }
    h += '<div class="vq-hero-duft">🌬️ ' + UI.scentLabel + ' ' + esc(oil.scent) + '</div>';
    h += '<div class="vq-hero-tipp">' + UI.tipLabel + ' ' + esc(tippText(oil)) + '</div>';

    /* Groessenwahl - nur wenn es wirklich mehrere kaufbare Varianten gibt */
    if (vs.length > 1) {
      h += '<div class="vq-groessen" role="group" aria-label="' + V2.groesseLabel + '">';
      for (var i = 0; i < vs.length && i < 3; i++) {
        h += '<button type="button" class="vq-groesse' + (i === 0 ? ' vq-on' : '') + '" data-vid="' + vs[i].id +
             '" data-preis="' + vs[i].preis + '">' + esc(vs[i].titel) + '<small>' + fmtPreis(vs[i].preis) + '</small></button>';
      }
      h += '</div>';
    }
    h += '<button type="button" class="vq-haupt-cta vq-add-to-cart ajax-add-to-cart-btn" data-variant-id="' + vs[0].id + '">' +
         (ueberrasch ? V2.ctaUeberrasch : V2.cta) + ' <span class="vq-cta-preis">· ' + fmtPreis(vs[0].preis) + '</span></button>';
    h += '<a class="vq-hero-link" href="' + getProductUrl(top.p.handle) + '">' + V2.zurSeite + '</a>';
    h += '<div class="vq-hero-kosten">' + V2.proAnwendung.replace('{p}', (vs[0].preis / 100 / 250).toFixed(2).replace('.', ',')) + '</div>';
    if (n > 0) h += '<div class="vq-sicher">🛡️ ' + V2.sicher.replace('{n}', n) + '</div>';
    hero.innerHTML = h;
    cardsWrap.appendChild(hero);

    /* Groessenwahl verdrahten */
    var gBtns = hero.querySelectorAll('.vq-groesse');
    var cta = hero.querySelector('.vq-haupt-cta');
    for (var gi = 0; gi < gBtns.length; gi++) {
      gBtns[gi].addEventListener('click', function() {
        for (var k = 0; k < gBtns.length; k++) gBtns[k].classList.remove('vq-on');
        this.classList.add('vq-on');
        var vid = this.getAttribute('data-vid'), pr = parseInt(this.getAttribute('data-preis'), 10);
        cta.setAttribute('data-variant-id', vid);
        cta.querySelector('.vq-cta-preis').textContent = '· ' + fmtPreis(pr);
        hero.querySelector('.vq-hero-kosten').textContent = V2.proAnwendung.replace('{p}', (pr / 100 / 250).toFixed(2).replace('.', ','));
        aktualisiereSticky(top.p.titel, this.textContent, pr, vid);
      });
    }
    inKorb(cta, top.p.titel);
    hero.querySelector('.vq-hero-link').addEventListener('click', function() {
      trackEvent('quiz_product_click', { quiz_product: top.p.titel });
      sendToSheet({ t: 'click', lang: V2.lang, r1: top.p.titel });
    });

    /* ── Nr. 2 und 3 als kompakte Zeilen ── */
    if (rest.length) {
      var box = document.createElement('div');
      box.className = 'vq-v2-block';
      var rh = '<h4 class="vq-zwischen">' + (ueberrasch ? '' : V2.auchPassend) + '</h4>';
      if (ueberrasch) rh = '<details class="vq-alt"><summary>' + V2.altAufklappen + '</summary>';
      for (var j = 0; j < rest.length; j++) {
        var rp = rest[j];
        rh += '<div class="vq-zeile" data-vid="' + rp.p.varianten[0].id + '" data-name="' + esc(rp.p.titel) + '">';
        if (rp.p.bild) rh += '<img src="' + rp.p.bild + '&width=120" alt="" loading="lazy" width="52" height="52">';
        rh += '<div class="vq-zeile-t"><div class="vq-zeile-n">' + esc(rp.p.titel) + '</div>' +
              '<div class="vq-zeile-m">' + (rp.r.match ? rp.r.match + '% Match · ' : '') + esc(rp.p.varianten[0].titel) + '</div></div>' +
              '<div class="vq-zeile-p">' + fmtPreis(rp.p.varianten[0].preis) + '</div>' +
              '<button type="button" class="vq-plus" aria-label="' + V2.hinzu + '">+</button></div>';
      }
      if (ueberrasch) rh += '</details>';
      box.innerHTML = rh;
      cardsWrap.parentNode.insertBefore(box, cardsWrap.nextSibling);
      verdrahteZeilen(box);

      /* Set-Knopf mit echtem Gesamtpreis */
      var summe = 0;
      for (var sj = 0; sj < paare.length; sj++) summe += paare[sj].p.varianten[0].preis;
      var setDiv = document.createElement('div');
      setDiv.className = 'vq-v2-block vq-set';
      setDiv.innerHTML = '<div class="vq-set-z"><span>' + V2.setTitel.replace('{n}', paare.length) + '</span><b>' + fmtPreis(summe) + '</b></div>' +
        '<button type="button" class="vq-set-btn">' + V2.setBtn + '</button>';
      box.parentNode.insertBefore(setDiv, box.nextSibling);
      setDiv.querySelector('.vq-set-btn').addEventListener('click', function() {
        var items = paare.map(function(x) { return { id: x.p.varianten[0].id, quantity: 1 }; });
        var b = this; b.disabled = true; b.textContent = V2.wirdHinzu;
        trackEvent('quiz_bundle_click');
        sendToSheet({ t: 'cart', lang: V2.lang, r1: 'SET (' + paare.length + ')' });
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function() { window.location.href = DISCOUNT_URL; })
          .catch(function() { b.textContent = V2.fehler; b.disabled = false; });
      });
    }

    /* ── Zubehoer passend zur Anwendung ── */
    if (zubehoer && zubehoer.ok) {
      var zb = document.createElement('div');
      zb.className = 'vq-v2-block';
      zb.innerHTML = '<h4 class="vq-zwischen">' + V2.dazuPasst + '</h4>' +
        '<div class="vq-zeile" data-vid="' + zubehoer.varianten[0].id + '" data-name="' + esc(zubehoer.titel) + '">' +
        (zubehoer.bild ? '<img src="' + zubehoer.bild + '&width=120" alt="" loading="lazy" width="52" height="52">' : '') +
        '<div class="vq-zeile-t"><div class="vq-zeile-n">' + esc(zubehoer.titel) + '</div>' +
        '<div class="vq-zeile-m">' + esc(V2.zubehoerText[answers[4]] || '') + '</div></div>' +
        '<div class="vq-zeile-p">' + fmtPreis(zubehoer.varianten[0].preis) + '</div>' +
        '<button type="button" class="vq-plus" aria-label="' + V2.hinzu + '">+</button></div>';
      cardsWrap.parentNode.appendChild(zb);
      verdrahteZeilen(zb);
    }

    /* ── Versandbalken ── */
    fetch('/cart.js').then(function(r) { return r.json(); }).then(function(c) {
      var schwelle = V2.versandSchwelle * 100;
      var fehlt = Math.max(0, schwelle - c.total_price);
      var vb = document.createElement('div');
      vb.className = 'vq-v2-block vq-versand';
      vb.innerHTML = (fehlt > 0
        ? V2.versandNoch.replace('{x}', '<b>' + fmtPreis(fehlt) + '</b>')
        : V2.versandFrei) +
        '<div class="vq-bar"><i style="width:' + Math.min(100, Math.round(c.total_price / schwelle * 100)) + '%"></i></div>';
      cardsWrap.parentNode.appendChild(vb);
    }).catch(function() {});

    /* ── Rabattcode, kompakt ── */
    var db = document.createElement('div');
    db.className = 'vq-v2-block vq-code';
    db.innerHTML = '<div><span class="vq-code-c">' + DISCOUNT_CODE + '</span><small>' + V2.codeText + '</small></div>' +
      '<a class="vq-code-btn" href="' + DISCOUNT_URL + '">' + V2.codeBtn + '</a>';
    cardsWrap.parentNode.appendChild(db);
    db.querySelector('.vq-code-btn').addEventListener('click', function() {
      trackEvent('quiz_discount_apply', { quiz_code: DISCOUNT_CODE });
    });

    /* ── Sticky-Kaufleiste (70 % der Nutzer sind am Handy) ── */
    var sticky = document.createElement('div');
    sticky.className = 'vq-sticky';
    sticky.innerHTML = '<div class="vq-sticky-t"><div class="vq-sticky-n"></div><div class="vq-sticky-p"></div></div>' +
      '<button type="button" class="vq-sticky-btn">' + V2.cta + '</button>';
    quizEl.appendChild(sticky);
    aktualisiereSticky(top.p.titel, vs[0].titel, vs[0].preis, vs[0].id);
    sticky.querySelector('.vq-sticky-btn').addEventListener('click', function() {
      var b = hero.querySelector('.vq-haupt-cta');
      if (b) b.click();
    });
    var beobachter = new IntersectionObserver(function(eintraege) {
      sticky.classList.toggle('vq-sichtbar', !eintraege[0].isIntersecting);
    }, { threshold: 0 });
    beobachter.observe(hero.querySelector('.vq-haupt-cta'));

    clearProgress();
    surveyEl.style.display = 'none';
    surveySubmitted = false;
    setTimeout(function() { if (!surveySubmitted) surveyEl.style.display = 'block'; }, 8000);
  }

  function aktualisiereSticky(name, groesse, preis, vid) {
    var st = quizEl.querySelector('.vq-sticky');
    if (!st) return;
    st.querySelector('.vq-sticky-n').textContent = name + (groesse ? ' · ' + String(groesse).split('\n')[0] : '');
    st.querySelector('.vq-sticky-p').textContent = fmtPreis(preis) + ' · ' + V2.versandKurz;
    st.setAttribute('data-vid', vid);
  }

  function verdrahteZeilen(wurzel) {
    var zeilen = wurzel.querySelectorAll('.vq-zeile');
    for (var i = 0; i < zeilen.length; i++) {
      (function(z) {
        z.querySelector('.vq-plus').addEventListener('click', function() {
          var vid = parseInt(z.getAttribute('data-vid'), 10);
          var nm = z.getAttribute('data-name');
          var b = this;
          if (!vid) return;
          b.disabled = true; b.textContent = '…';
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
            .then(function() {
              b.textContent = '✓'; b.classList.add('vq-ok');
              trackEvent('quiz_add_to_cart', { quiz_product: nm });
              sendToSheet({ t: 'cart', lang: V2.lang, r1: nm });
              setTimeout(function() { b.textContent = '+'; b.classList.remove('vq-ok'); b.disabled = false; }, 2200);
            })
            .catch(function() { b.textContent = '!'; b.disabled = false; });
        });
      })(zeilen[i]);
    }
  }

  function inKorb(btn, name) {
    btn.addEventListener('click', function() {
      var vid = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (!vid) return;
      var alt = btn.innerHTML;
      btn.disabled = true; btn.textContent = V2.wirdHinzu;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] }) })
        .then(function() {
          btn.innerHTML = '✓ ' + V2.imKorb;
          btn.classList.add('vq-ok');
          trackEvent('quiz_add_to_cart', { quiz_product: name });
          sendToSheet({ t: 'cart', lang: V2.lang, r1: name });
          setTimeout(function() { btn.innerHTML = alt; btn.classList.remove('vq-ok'); btn.disabled = false; }, 2500);
        })
        .catch(function() { btn.textContent = V2.fehler; btn.disabled = false; });
    });
  }

  /* Tipp passend zur gewaehlten Anwendung (Frage 5), sonst der Standardtipp. */
  function tippText(oil) {
    if (answers[4] !== undefined && V2.tipp[answers[4]]) return V2.tipp[answers[4]];
    return oil.tip;
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function(c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  quizEl.querySelector('.vq-start-btn').addEventListener('click', startQuiz);

  quizEl.querySelector('.vq-btn-back').addEventListener('click', goBack);



  (function() {

    var saved = loadProgress();

    if (!saved) return;

    var startBtn = quizEl.querySelector('.vq-start-btn');

    var resumeBtn = document.createElement('button');

    resumeBtn.type = 'button';

    resumeBtn.className = 'vq-btn vq-btn-primary';

    resumeBtn.style.cssText = 'background:#2d572c;margin-top:0.5rem;';

    resumeBtn.textContent = '↻ Continuare da dove ha lasciato (Domanda ' + (saved.step + 1) + ')';

    startBtn.parentNode.insertBefore(resumeBtn, startBtn.nextSibling);

    startBtn.textContent = 'Ricominciare';

    startBtn.className = 'vq-btn vq-btn-back';

    resumeBtn.addEventListener('click', function() { resumeQuiz(saved); });

  })();



  var restartBtn = quizEl.querySelector('.vq-btn-restart');

  restartBtn.addEventListener('click', function() {

    currentStep = -1;

    answers = [];

    clearProgress();

    surveySubmitted = false;

    quizEl.querySelector('.vq-survey-thanks').style.display = 'none';

    surveyEl.style.display = 'none';

    showScreen('intro');

  });



  /* ── SURVEY ── */

  var surveyEl = quizEl.querySelector('.vq-survey');

  var quizStars = quizEl.querySelectorAll('#vq-stars-quiz .vq-star');

  var oilsStars = quizEl.querySelectorAll('#vq-stars-oils .vq-star');

  var quizRating = 0;

  var oilsRating = 0;

  var surveySubmitted = false;



  for (var si = 0; si < quizStars.length; si++) {

    (function(star) {

      star.addEventListener('click', function() {

        quizRating = parseInt(this.getAttribute('data-value'), 10);

        for (var j = 0; j < quizStars.length; j++) {

          quizStars[j].classList.toggle('vq-star-active', parseInt(quizStars[j].getAttribute('data-value'), 10) <= quizRating);

        }

      });

      star.addEventListener('mouseenter', function() {

        var hv = parseInt(this.getAttribute('data-value'), 10);

        for (var j = 0; j < quizStars.length; j++) {

          quizStars[j].classList.toggle('vq-star-hover', parseInt(quizStars[j].getAttribute('data-value'), 10) <= hv);

        }

      });

      star.addEventListener('mouseleave', function() {

        for (var j = 0; j < quizStars.length; j++) { quizStars[j].classList.remove('vq-star-hover'); }

      });

    })(quizStars[si]);

  }



  for (var oi = 0; oi < oilsStars.length; oi++) {

    (function(star) {

      star.addEventListener('click', function() {

        oilsRating = parseInt(this.getAttribute('data-value'), 10);

        for (var j = 0; j < oilsStars.length; j++) {

          oilsStars[j].classList.toggle('vq-star-active', parseInt(oilsStars[j].getAttribute('data-value'), 10) <= oilsRating);

        }

      });

      star.addEventListener('mouseenter', function() {

        var hv = parseInt(this.getAttribute('data-value'), 10);

        for (var j = 0; j < oilsStars.length; j++) {

          oilsStars[j].classList.toggle('vq-star-hover', parseInt(oilsStars[j].getAttribute('data-value'), 10) <= hv);

        }

      });

      star.addEventListener('mouseleave', function() {

        for (var j = 0; j < oilsStars.length; j++) { oilsStars[j].classList.remove('vq-star-hover'); }

      });

    })(oilsStars[oi]);

  }



  quizEl.querySelector('.vq-btn-survey-submit').addEventListener('click', function() {

    if ((quizRating === 0 && oilsRating === 0) || surveySubmitted) return;

    var comment = quizEl.querySelector('#vq-survey-tips').value || '';

    var emailInput = quizEl.querySelector('#vq-survey-email');

    var email = emailInput ? (emailInput.value || '').trim() : '';

    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {

      emailInput.style.borderColor = '#dc2626';

      emailInput.focus();

      return;

    }

    sendToSheet({

      t: 'feedback', lang: 'it',

      stars_quiz: quizRating, stars_oils: oilsRating,

      comment: comment.substring(0, 200),

      email: email.substring(0, 100)

    });

    trackEvent('quiz_feedback', { quiz_stars: quizRating, oils_stars: oilsRating, has_email: email ? 1 : 0 });

    surveySubmitted = true;

    surveyEl.style.display = 'none';

    quizEl.querySelector('.vq-survey-thanks').style.display = 'block';

  });



})();

